export enum ReportContentReasonEnum {
  OFFENSIVE_OR_HARMFUL = "Offensive or Harmful",
  INACCURATE = "Inaccurate",
  OTHER = "Other",
}
